import type { PlateElementProps, PlateLeafProps } from "platejs/react";
import { PlateElement, PlateLeaf } from "platejs/react";
import { cn } from "@/lib/utils";

export function CodeBlockElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement
			{...props}
			as="pre"
			className={cn(
				"my-2 overflow-x-auto rounded-lg border bg-muted/50 px-4 py-3 font-mono text-sm leading-[normal]",
				className,
			)}
		>
			<code>{children}</code>
		</PlateElement>
	);
}

export function CodeLineElement({ children, ...props }: PlateElementProps) {
	return (
		<PlateElement {...props} as="div">
			{children}
		</PlateElement>
	);
}

export function CodeSyntaxLeaf({ children, className, leaf, ...props }: PlateLeafProps) {
	const tokenType = leaf.tokenType as string | undefined;

	return (
		<PlateLeaf
			{...props}
			leaf={leaf}
			className={cn(
				tokenType === "comment" && "text-muted-foreground",
				tokenType === "keyword" && "text-blue-400",
				tokenType === "string" && "text-green-400",
				tokenType === "number" && "text-orange-400",
				tokenType === "function" && "text-yellow-300",
				tokenType === "operator" && "text-pink-400",
				className,
			)}
		>
			{children}
		</PlateLeaf>
	);
}
